<template>
<site-device-info-map :site-infos="data" :get-window-content="getWindowContent" />
</template>

<script>
import BaseModule from './BaseModule'
import AreaAQI from './AreaAQI'
import SiteDeviceInfoMap from './SiteDeviceInfoMap'

export default {
  name: 'RealSiteDeviceInfoMap',
  extends: BaseModule,
  components: {SiteDeviceInfoMap},
  data () {
    return {
      beginTS: 0,
      data: Object.freeze([]),
      nowAQI: [],
      timer: null
    }
  },
  computed: {
    apiKey: () => ['getNowAQI', 'getCurrentDeviceStatus'],
    profileSiteDeviceMap () {
      return this.profileSiteDevices.reduce((map, siteDevice) => {
        let {siteId} = siteDevice
        let siteDevices = map[siteId]

        if (!siteDevices) {
          siteDevices = map[siteId] = []
        }

        siteDevices.push(siteDevice)

        return map
      }, {})
    },
    sieAQIMap () {
      return this.nowAQI.reduce((map, nowAQI) => {
        map[nowAQI.areaId] = nowAQI
        return map
      }, {})
    }
  },
  methods: {
    getSiteMap (sites, siteDeviceStatusList) {
      return (siteDeviceStatusList || []).reduce((map, siteDeviceStatus) => {
        let site = map[siteDeviceStatus.siteId]

        if (site) {
          site.devices.push({
            id: siteDeviceStatus.siteDeviceId,
            name: siteDeviceStatus.siteDeviceName,
            status: siteDeviceStatus.status
          })
        }

        return map
      }, sites.reduce((map, site) => {
        let {id} = site
        map[id] = {
          id,
          name: site.name,
          longitude: site.longitude,
          latitude: site.latitude,
          bgColor: '#999999',
          devices: []
        }

        return map
      }, {}))
    },
    clearTimeInterval () {
      clearInterval(this.timer)
    },
    setSiteColor (sites) {
      // let {profileSiteDeviceMap} = this

      // sites.forEach(site => {
      //   let {devices} = site
      //   let siteDevices = profileSiteDeviceMap[site.id]
      //   site.bgColor = devices.length === 0
      //     ? '#00e400'
      //     : (
      //       devices.length === siteDevices.length
      //         ? '#ff0000'
      //         : '#ff7e00'
      //     )
      // })

      let {sieAQIMap} = this
      let {profileSiteDeviceMap} = this

      sites.forEach(site => {
        let siteAQI = sieAQIMap[site.id]

        if (siteAQI) {
          site.bgColor = siteAQI.aqiColor
        } else {
          let {devices} = site
          let siteDevices = profileSiteDeviceMap[site.id]
          site.bgColor = devices.length === 0
            ? '#00e400'
            : (
              devices.length === siteDevices.length
                // ? '#ff0000'
                ? '#999999'
                : '#ff7e00'
            )
        }
      })
    },
    getTS (dateStr) {
      return new Date(`${dateStr}:00:00`).getTime()
    },
    onRealDataReceived ([aqiData, data]) {
      this.setNowAQIData(aqiData)
      let sites = Object.values(this.getSiteMap(this.profileSites, data.data))
      this.setSiteColor(sites)

      this.data = Object.freeze(sites)
      this.beginTS = this.getTS(data.beginTime)
    },
    getWindowContent (site) {
      let {devices} = site
      let {nowAQI} = this

      if (devices.length === 0) {
        if (!nowAQI.find(el => el.areaId === site.id)) {
          return false
        }
        return `
          <section style="font-size:14px;border-radius:6px;color:#fff;overflow:hidden;">
            <section style="display:flex;justify-content:space-between;align-items:center;line-height:30px;padding:0 10px;background:rgba(0,21,62,.8);">
              <span>${site.name}</span>
            </section>
            <section style="padding:10px 5px;background:rgba(0,21,62,.5);">
              ${nowAQI.map(el => {
    if (el.areaId === site.id) {
      return `
                    <div style="width: 100%; height: 140px;">
                      <p style="margin:0;font-size: 1em;text-align: center;">AQI数据更新时间： ${new Date(el.dataTime).format('YYYY-MM-DD HH:mm:ss')}<br />首要污染物：${el.primary} <span style="margin-left: 8px;"></span> AQI指数： <span style="color: ${el.aqiColor};">${el.aqi} ${el.levelName}</span><p>
                      <div style="display: flex;flex-wrap: wrap;justify-content:space-between;align-items:center;">
                      ${el.values.map(value => {
    return `
                          <div style="width: 48%;text-align:center;padding: 5px 0;">
                            <span>${value.name}: <span style="color: ${value.color}; font-size: 15px;">${value.value}</span>(<span style="font-size: 10px;">${value.unit}</span>)</span>
                          </div><br />`
  }).join('')}
                      </div>
                    </div>
                  `
    }
  }).filter(Boolean).join('')}
            </section>
          </section>
          <section style="display:flex;justify-content:center;height:0;">
            <div style="border:8px solid transparent;border-top-color:rgba(0,21,62,.5);"></div>
          </section>
        `
      }

      let {beginTS} = this

      return `
        <section style="font-size:14px;border-radius:6px;color:#fff;overflow:hidden;">
          <section style="display:flex;justify-content:space-between;align-items:center;line-height:30px;padding:0 10px;background:rgba(0,21,62,.8);">
            <span>${site.name}</span>
          </section>
          <section style="padding:10px 5px;background:rgba(0,21,62,.5);">
            <table>
              <thead>
              <tr>
                <th>设备</th>
                <th>状态</th>
              </tr>
              </thead>
              <tbody>
                ${devices.map(({name, status}) => `
                <tr>
                  <td align="right" style="padding:5px;">${name}</td>
                  <td style="padding:5px;">
                    <section style="display:flex;">
                      ${new Array(24).fill(null).map((n, index) => `<div title="${new Date(beginTS + index * 3600000).format('YYYY-MM-DD HH')}" style="width:7px;height:14px;margin-left:-1px;border:1px solid #686565;${status & (1 << index) ? 'background:rgba(0,228,0,.5);' : ''}"></div>`).join('')}
                    </section>
                  </td>
                </tr>
                `).join('')}
              </tbody>
            </table>
            ${nowAQI.map(el => {
    if (el.areaId === site.id) {
      return `
        <div style="width: 100%; height: 140px; margin-top: 15px; padding: 0 10px;">
          <p style="margin:0;font-size: 1em;text-align: center;">AQI数据更新时间： ${new Date(el.dataTime).format('YYYY-MM-DD HH:mm:ss')}<br />首要污染物：${el.primary} <span style="margin-left: 8px;"></span> AQI指数： <span style="color: ${el.aqiColor};">${el.aqi} ${el.levelName}</span><p>
          <div style="display: flex;flex-wrap: wrap;justify-content:space-between;align-items:center;">
          ${el.values.map(value => {
    return `
      <div style="width: 48%;text-align:center;padding: 5px 0;">
        <span>${value.name}: <span style="color: ${value.color}; font-size: 15px;">${value.value}</span>(<span style="font-size: 10px;">${value.unit}</span>)</span>
      </div>`
  }).join('')}
  </div>
</div>`
    }
  }).filter(Boolean).join('')}
          </section>
        </section>
        <section style="display:flex;justify-content:center;height:0;">
          <div style="border:8px solid transparent;border-top-color:rgba(0,21,62,.5);"></div>
        </section>
      `
    },
    setNowAQIData (data) {
      let level = {
        1: '优',
        2: '良',
        3: '轻度污染',
        4: '中度污染',
        5: '重度污染',
        6: '严重污染'
      }
      let aqiData = data.map(el => {
        let factors = {
          'PM2.5': '--',
          'PM10': '--',
          'O3': '--',
          'NO2': '--',
          'SO2': '--',
          'CO': '--'
        }

        for (let key in factors) {
          el.pollutantData.forEach(item => {
            if (item.rootFactorId === key) {
              factors[key] = Number(item.value.toFixed(2))
            }
          })
        }

        return [
          el.siteId,
          el.siteId,
          el.dataTime,
          Number.isFinite(el.aqi) ? Number(el.aqi.toFixed(2)) : '--',
          el.grade,
          level[el.grade],
          el.primaryPollutant.replaceAll('_24H', ''),
          '--',
          ...Object.values(factors)
        ]
      })

      this.nowAQI = aqiData.map(el => new AreaAQI(...el))
    }
  }
  // created () {
  //   this.getNowAQIData()
  //   this.setTimeInterval()
  // },
  // beforeDestroy () {
  //   this.clearTimeInterval()
  // }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/01Data-Overview/RealSiteDeviceInfoMap.vue